<template>
  <VView class="contest-results" back-button-to="/contest/game" header="Wynik">
    <VText center>Twój wynik to</VText>
    <VText center big><span>{{ score }}</span></VText>
    <VText center v-show="scoresLoaded">udało ci się uzyskać wynik lepszy niż <span>{{ worse }}</span> graczy.<br />Jesteś wśród <span>{{ percent }}%</span> najlepszych.</VText>

    <!-- <VText center>zasubskrybuj pufkowy kanał na youtube!<br />zapisz swój wynik, aby brać udział w walce o nagrody!</VText> -->
    <VText center>zasubskrybuj pufkowy kanał na youtube!</VText>

    <VBlock max-width="500px">
      <transition name="bounceUp" appear>
        <VButton href="https://www.youtube.com/@PRZYGODY_PUFKA?sub_confirmation=1">Pufek na YouTube</VButton>
      </transition>

      <transition name="bounceUp" appear>
        <VButton to="/contest/personal">Zapisz wynik!</VButton>
      </transition>
    </VBlock>
  </VView>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ContestInstructions',

  data: () => ({
    scoresLoaded: false,
    worse: 0,
    percent: 0,
  }),

  async mounted() {
    const { data: players } = await this.$bricodes.getPublicEntries();

    const scores = players
      .filter(player => !player.isFavorite && player.isConfirmed && player.result.score !== undefined)
      .map(player => player.result.score);

    const totalScores = scores.length;
    const worseScores = scores.filter(score => score < this.score).length;
    const betterScores = totalScores - worseScores;

    this.worse = worseScores;
    this.percent = Math.ceil((betterScores / totalScores) * 100);

    this.scoresLoaded = true;
  },

  computed: {
    ...mapState({
      score: (state) => state.score,
    }),
  },
};
</script>

<style lang="scss" scoped>
.contest-results {
  ::v-deep .view__content .text--big {
    font-size: font(40px, 100px);
    margin-top: 0 !important;
  }

  ::v-deep .button:first-child .button__content {
    padding-top: 10px;
    padding-bottom: 7px;
    margin-bottom: -10px;
    background-color: #a72c23;

    font-size: font(20px, 30px);

    &:hover {
      background-color: #8e231d;
    }
  }
}
</style>
